import * as React from "react"
import { Appearance, StyleProp, TextStyle, View, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Input } from "../input/input"
import { Icon } from "native-base"
import MaterialIcons from "react-native-vector-icons/MaterialIcons"
import { TxKeyPath } from "../../i18n"
import { Button } from "../button/button"
import { Text } from "../text/text"


const CONTAINER: ViewStyle = {
  justifyContent: "center",
  alignItems: 'center',
  flexDirection: "row"
}

const INPUT_STYLE: TextStyle = {
  flex: 1,
  backgroundColor: color.palette.backgroundGray
}

const BTN: ViewStyle = {
  width: '23%',
  height: 40,
  marginLeft: 10,
}



export interface SearchBarProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
  placeholder?: TxKeyPath
  onChangeText?: (value: string) => void
  onSubmitEditing?: () => void
  colorScheme?: "light" | "dark"
  onPress?: () => void
  title?: TxKeyPath
  value?: string
}

/**
 * Describe your component here
 */
export const SearchBar = observer(function SearchBar(props: SearchBarProps) {
  const { placeholder, onChangeText, onSubmitEditing, onPress, value, title, colorScheme = "light" || Appearance.getColorScheme() } = props

  return (
    <View style={CONTAINER}>
      <Input style={INPUT_STYLE} InputLeftElement={<Icon as={<MaterialIcons name="search"></MaterialIcons>} size={"24px"} ml={"5px"} textAlign="center" color={color.palette.gray700} />}
        placeholderTx={placeholder}
        onChangeText={onChangeText}
        value={value}
        onSubmitEditing={onSubmitEditing}
        colorScheme={colorScheme}
        keyboardType="web-search"
      />
      <Button testID="jala:id/search-button" colorScheme={colorScheme} onPress={onPress} style={BTN}>
        <Text preset="title4" tx={title} colorScheme={colorScheme} color={color.palette.white} />
      </Button>
    </View>
  )
})
